import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCurrentUser from '../reducers/currentUser.reducer';

export const selectCurrentUserState = createFeatureSelector<fromCurrentUser.CurrentUserState>(fromCurrentUser.dataFeatureKey);

export const selectCurrentAccount = createSelector(selectCurrentUserState, (state) => state.currentAccount);
